import { ENERGY_COST_BASE_ROUTE, TABS } from '@/src/utils/constants'
import React, { Suspense } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

const EnergyCostLazy = React.lazy(() => import('./Energiekosten.screen'))
const InvoiceDetailsLazy = React.lazy(() => import('./invoice-audit/InvoiceDetails.screen'))
const InvoiceAuditsLazy = React.lazy(() => import('./invoice-audit/InvoiceAudits.page'))
const BudgetLazy = React.lazy(() => import('./kostenverlauf/Budget.screen'))

const ProcurementPage = (
  <Suspense fallback={<div />}>
    <EnergyCostLazy />
  </Suspense>
)

const InvoiceAuditPage = (
  <Suspense fallback={<div />}>
    <InvoiceAuditsLazy />
  </Suspense>
)

const InvoiceDetailsPage = (
  <Suspense fallback={<div />}>
    <InvoiceDetailsLazy />
  </Suspense>
)

const BudgetPage = (
  <Suspense fallback={<div />}>
    <BudgetLazy />
  </Suspense>
)

export const getEnergyCostRoutes = (): RouteObject[] => {
  const defaultRedirection = TABS.energiekosten.trend

  return [
    {
      path: ENERGY_COST_BASE_ROUTE,
      element: (
        <AuthRoute>
          <LayoutMain />
        </AuthRoute>
      ),
      children: [
        { path: '', element: <Navigate to={defaultRedirection} replace />, index: true },
        {
          path: '',
          element: ProcurementPage,
          children: [
            { path: TABS.energiekosten.trend, element: BudgetPage },
            { path: TABS.energiekosten.audit, element: InvoiceAuditPage },
          ],
        },
        { path: `${TABS.energiekosten.audit}/:id`, element: InvoiceDetailsPage },
      ],
    },
  ]
}
